import React from 'react'
import { Dropdown } from 'antd'
import { AlignCenterOutlined, CloseOutlined } from '@ant-design/icons'
import styles from './filters.module.css'

const FiltersButton = ({
  showFilters,
  setShowFilters,
  selectedFilters,
  containerRef,
  filterPopupContent,
  crossButtonClick,
}) => {
  // determine if any filters selected
  const hasFilters = Object.values(selectedFilters || {}).some(
    arr => Array.isArray(arr) && arr.length > 0
  )
  return (
    <div style={{ position: 'relative' }}>
      <Dropdown
        visible={showFilters}
        onVisibleChange={setShowFilters}
        overlay={filterPopupContent}
        trigger={['click']}
        placement="bottomRight"
        getPopupContainer={() => containerRef.current}
      >
        <button type="submit" className={styles.searchButton}>
          <div
            className={`${styles.buttonContent} ${
              selectedFilters?.industry?.length > 0 ||
              selectedFilters?.platform?.length > 0 ||
              selectedFilters?.performance?.length > 0 ||
              selectedFilters?.adIndustry?.length > 0
                ? styles.buttonContentWithClose
                : ''
            }`}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold' }}>
              <AlignCenterOutlined /> Filters
              {hasFilters && (
                <CloseOutlined
                  className={styles.closeIcon}
                  onClick={e => {
                    e.stopPropagation()
                    crossButtonClick()
                  }}
                />
              )}
            </span>
          </div>
        </button>
      </Dropdown>
    </div>
  )
}

export default FiltersButton
